import React, { useState } from 'react'
import AvatarImage from '../avatarImage'
import { ProfileButton } from '../Generic'
import ProfilePostCard from '../ProfilePostCard';
import { avatar } from '../../assets';
import { Link } from 'react-router-dom';


const Index = ({
  Follower, 
  Following, 
  Lessons, 
  profilePic, 
  blue,
  profession,
  name,
  info,
  Telegram,
  Instagram,
  Facebook,
  firstBtn,
  btnBackground,
  style,
  secondBtn,
  thirdBtn,
  firstBtnLink,
  secondBtnLink,
  thirdBtnLink,
  btnColor

}) => {
  const [active, setActive] = useState('all');
  // FCFCFC
  return (
    <>
      <div className='bg-[#FCFCFC] rounded-t-[50px] w-full mt-[18px]'>
        <div className='mx-[30px] md:w-[600px] '>
          <section className='flex justify-around  md:items-start mb-[10px]'>
            <div className=''>
              <AvatarImage img={profilePic}/>
            </div>

            <div className='mt-[50px] md:m-10'>
            <div className='flex justify-between gap-5 w-full md:gap-10 md:mt-10'>
            <Link to='/followers' className='flex flex-col justify-center text-center'>
              <div className='md:text-[17px] text-[15px] font-bold'>{Follower || '0'}</div>
              <div className='md:text-[17px] text-[15px]'>Followers</div>
            </Link>
            <Link to='/followers' className='flex flex-col justify-center text-center'>
              <div className='md:text-[17px] text-[15px] font-bold'>{Following || '0'}</div>
              <div className='md:text-[17px] text-[15px]'>Following</div>
            </Link>

            <Link to={'/lessons'} className='flex flex-col justify-center text-center'>
              <div className='md:text-[17px] text-[15px] font-bold'>{Lessons || '0'}</div>
              <div className='md:text-[17px] text-[15px]'>Lessons</div>
            </Link>
            </div>
              <section className='hidden md:block'>
            <div className='text-[14px] mt-4'>{profession || 'profession'}</div>
            <div className='font-bold text-[16px]'>{name || 'users name'}</div>
            <div className='text-[16px] text-[#6C7A9C]'>{info || 'User information'}</div>
            <div className='flex gap-5 text-[16px] text-[#347AE2]'>
              <a href={Telegram}>Telegram</a>
              <a href={Instagram}>Instagram</a>
              <a href={Facebook}>Facebook</a>
            </div>
          </section>
            </div>

          </section>
          <section className='block md:hidden'>
            <div className='text-[10px]'>{profession || 'profession'}</div>
            <div className='font-bold text-[13px]'>{name || 'User name'}</div>
            <div className='text-[13px] text-[#6C7A9C]'>{info || 'User information'}</div>
            <div className='flex gap-5 text-[13px] text-[#347AE2]'>
              <a href={Telegram}>Telegram</a>
              <a href={Instagram}>Instagram</a>
              <a href={Facebook}>Facebook</a>
            </div>
          </section>
          <section className='flex w-full max-w-[400px] gap-[10px] mt-[16px] justify-between mr-[100px]'>
            <ProfileButton link={firstBtnLink} background={`${btnBackground} `} style={style} color={btnColor} blue={blue} value={firstBtn}/>
            <ProfileButton link={secondBtnLink} background={'white'} value={secondBtn}/>
            <ProfileButton link={thirdBtnLink} background={'white'} value={thirdBtn}/>
          </section>
          <section className='flex justify-around mt-[21px]'>
            <div className='cursor-pointer'>
            <div onClick={()=>setActive('all')}>All</div>
            <div className={active === "all" ? 'bg-[#6C7A9C] h-[3px] w-full rounded-[2px]' : 'bg-inherit h-[4px] w-[10px]' }></div>
            </div>
            <div className='cursor-pointer'>
            <div onClick={()=>setActive('contact')}>Bepul darslar</div>
            <div className={active === "contact" ? 'bg-[#6C7A9C] h-[3px] w-full rounded-[2px]' : 'bg-inherit h-[4px] w-[10px]' }></div>
            </div>
            <div className='cursor-pointer'>
            <div onClick={()=>setActive('dios')}>Premium darslar</div>
            <div className={active === "dios" ? 'bg-[#6C7A9C] h-[3px] w-full rounded-[2px]' : 'bg-inherit h-[4px] w-[10px]' }></div>
            </div>
            <div className='cursor-pointer'>
            <div onClick={()=>setActive('asdas')}>Saved</div>
            <div className={active === "asdas" ? 'bg-[#6C7A9C] h-[3px] w-full rounded-[2px]' : 'bg-inherit h-[4px] w-[10px]' }></div>
            </div>
          </section>
          <section className='mt-[12px] grid grid-cols-3 gap-[1px] lg:max-w-[1100px] lg:min-w-[810px] lg:w-full'>
          <ProfilePostCard />
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          <ProfilePostCard/>
          </section>
        </div>
      </div>  
    </>
  )
}

export default Index